import React, { Component } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';

import { redirectToPathIf } from '../../utils/authorization';
import { logout } from '../../actions/users';
import { awardsRoute } from '../../routes';

import connect from '../../utils/connect';

class AccountLogout extends Component {

	constructor(props) {
		super();
	}

	componentWillMount(props) {
		redirectToPathIf(this.props.dispatch, awardsRoute(), !this.props.users.isLoggedIn());

		this.props.dispatch(logout());
	}

	render() {
		return (
			<div className='account-logout'>
				<Helmet title='The FWA - Logout' />
			</div>
		);
	}
}

export default connect(AccountLogout);



/** WEBPACK FOOTER **
 ** ./frontend/containers/account/logout.js
 **/